import { EndpointsOptionsMap } from '../system';
import * as experienceApi from './experience';

export type ExperienceApiEndpointTypes = EndpointsOptionsMap<
  typeof experienceApi
>;
export { experienceApi };
